// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"112":"a9a7754c","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"112":"e5f97bbe9d11b3c0bfff","175":"87f5577df1c6b8b7da1a","231":"48c4c74a15808767110d","678":"ddd462970b0b1f1b856f","876":"84b3a703480629967391","883":"d54cc2feed0068bceaf4"}[chunkId] + ".js";
};